import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/purchase-orders', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/v1/purchase-orders/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/purchase-orders', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/v1/purchase-orders/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/v1/purchase-orders/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const supplier = (Options = {}) => {
  return httpClient
    .get('/api/v1/purchase-orders/suppliers', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const product = (Options = {}) => {
  return httpClient
    .get('/api/v1/purchase-orders/product-profiles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const measure = (Options = {}) => {
  return httpClient
    .get('/api/v1/purchase-orders/measure-product-profiles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const vendor = (Options = {}) => {
  return httpClient
    .get('/api/v1/purchase-orders/vendors', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const printPdf = id => {
  return httpClient
    .get(`/api/v1/purchase-orders/${id}/print-pdf`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const purchaseType = (Options = {}) => {
  return httpClient
    .get('/api/v1/purchase-orders/purchase-types', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const downloadTemplate = (data = {}) => {
  return httpClient
    .post('/api/v1/purchase-orders/download-templates', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export default {
  get,
  find,
  store,
  update,
  destroy,
  supplier,
  product,
  measure,
  printPdf,
  vendor,
  purchaseType,
  downloadTemplate
}